import React from "react";
import "./inputContainer.scss";

export default function InputContainer(props: any) {
  const { children } = props;
  return <div className="input-container">{children}</div>;
}
